import SelectIcon from './component'

export default SelectIcon
